import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CalendarFilter } from 'src/app/models/CalendarFilter';
import { ClassAndClassCode } from 'src/app/models/CalendarModels';
import { OptionSet } from 'src/app/models/OptionSet';
import { CalendarService } from 'src/app/services/calendar.service';
import { MultiSelectSearchComponent } from '../multi-select-search/multi-select-search.component';
import { SchedulesService } from 'src/app/services/schedules.service';

@Component({
  selector: 'app-students-search',
  templateUrl: './students-search.component.html',
  styleUrls: ['./students-search.component.scss']
})
export class StudentsSearchComponent implements OnInit {
  @ViewChild(MultiSelectSearchComponent) filterClass: MultiSelectSearchComponent;
  @ViewChild(MultiSelectSearchComponent) filterCode: MultiSelectSearchComponent;
  @ViewChild(MultiSelectSearchComponent) filterType: MultiSelectSearchComponent;
  @ViewChild(MultiSelectSearchComponent) filterAfternoon: MultiSelectSearchComponent;
  @ViewChild(NgSelectComponent) filterCamp: NgSelectComponent;

  // @ViewChild(MultiSelectSearchComponent) filterCamp : MultiSelectSearchComponent;




  dropdownSettings: IDropdownSettings = {
    idField: 'value',
    textField: 'viewValue',
    enableCheckAll: true,
    selectAllText: 'בחר הכל',
    unSelectAllText: 'בטל הכל',
    itemsShowLimit: 3,
  };



  ClassesList: Array<OptionSet> = new Array<OptionSet>();
  ClassCodesList: Array<OptionSet> = new Array<OptionSet>();
  ClassAndCodeList: Array<OptionSet> = new Array<OptionSet>();
  ClassificationList: Array<OptionSet> = new Array<OptionSet>();
  CampList: Array<OptionSet> = new Array<OptionSet>();
  afternoon: Array<OptionSet> = [
    { value: "false", viewValue: "לא" },
    { value: "true", viewValue: "כן" }
  ];

  // selectedValues: Array<Array<OptionSet>> = new Array<Array<OptionSet>>();
  dataFilter: CalendarFilter = new CalendarFilter();


  isReadonly: boolean = false;

  constructor(public calendarSvc: CalendarService, public schedulesSvc: SchedulesService
  ) {
    this.ClassesList = this.calendarSvc.ClassesList;
    this.ClassCodesList = this.calendarSvc.ClassCodesList;
    this.ClassificationList = this.calendarSvc.ClassificationList;
    this.CampList = this.calendarSvc.CampList;
  }


  ngOnInit() {

  }

  optionSelected_Classes(e: Array<OptionSet>) {
    this.schedulesSvc.selectedClasses = [...e];
    this.dataFilter.ClassesValues = e.map(x => x.viewValue);
    this.ClassAndCodeList = [];
    e.forEach(c => {
      this.calendarSvc.ClassCodesList.forEach(cc => {
        let op: OptionSet = {
          viewValue: c.viewValue + cc.viewValue, value: c.value + cc.value
        }
        this.ClassAndCodeList.push(op);
      });
      // this.dataFilter.ClassAndCode = e.map(x => {
      //   let value: ClassAndClassCode = { Title: x.viewValue, Class: x.value }
      //   return value;
      // });
    });
    this.filter();
  }
  optionSelected_Numbers(e: Array<OptionSet>) {
    // this.dataFilter.ClassesCodesValues = e.map(x => x.viewValue);
    this.schedulesSvc.selectedClassCodes = [...e];
    this.dataFilter.ClassAndCode = e.map(x => {
      let value: ClassAndClassCode = { Title: x.viewValue, Class: x.value.substring(0, 3), ClassCode: x.value.substring(3) }
      return value;
    });
    this.filter();
  }
  optionSelected_Types(e: Array<OptionSet>) {
    this.schedulesSvc.selectedClassification = [...e];
    this.dataFilter.ClassificationValues = e.map(x => x.viewValue);
    this.filter();
  }
  optionSelected_Afternoon(e: Array<OptionSet>) {
    this.schedulesSvc.selectedAfternoon = [...e];
    if (e.length == 0)
      this.dataFilter.Afternoon = -1;
    else
      this.dataFilter.Afternoon = e[0].value == "true" ? 1 : 0;
    this.filter();
  }
  optionSelected_Camp(e: OptionSet) {
    this.schedulesSvc.selectedCamp = e;
    console.log(e);
    this.calendarSvc.IsFilterbYCamp.emit(e != null && e != undefined ? true : false);
    this.calendarSvc.selectedCamp = e;
    this.dataFilter.Camp = e != null && e != undefined ? e.viewValue : "";
    this.filter();
  }

  filter() {
    if (this.dataFilter.ClassesValues.length == 0 &&
      /*this.dataFilter.ClassesCodesValues.length == 0 &&*/
      this.dataFilter.ClassAndCode.length == 0 &&
      this.dataFilter.ClassificationValues.length == 0 &&
      this.dataFilter.Afternoon == -1 &&
      this.dataFilter.Camp == "")
      this.dataFilter.clearFilter = true;
    else
      this.dataFilter.clearFilter = false;
    this.calendarSvc.filterCalendar(this.dataFilter);
  }

  clearFilter() {
    this.schedulesSvc.selectedClasses = [];
    this.schedulesSvc.selectedClassCodes = [];
    this.schedulesSvc.selectedClassification = [];
    this.schedulesSvc.selectedAfternoon = [];
    this.schedulesSvc.selectedCamp = null;
    this.filterClass.clearFilter();
    this.filterCode.clearFilter();
    this.filterType.clearFilter();
    //this.filterCamp.clearFilter();
    this.filterAfternoon.clearFilter();
    this.filterCamp.clearModel();
    this.dataFilter.clearFilter = true;
    this.calendarSvc.filterCalendar(this.dataFilter);
  }

}
